import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CitrusSlice, Sun, PalmLeaf } from './DecorativeShapes';
export const Hero = () => {
  return <section className="relative w-full min-h-[70vh] flex items-center justify-center overflow-hidden bg-sand-100 px-6 py-20" data-id="element-44">
      {/* Decorative Background Elements */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8,
      rotate: -20
    }} animate={{
      opacity: 1,
      scale: 1,
      rotate: 0
    }} transition={{
      duration: 1,
      delay: 0.2
    }} className="absolute top-10 left-10 md:top-20 md:left-20 text-citrus-400 w-24 h-24 md:w-40 md:h-40 opacity-60" data-id="element-45">
        <Sun data-id="element-46" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      x: 50,
      rotate: 45
    }} animate={{
      opacity: 1,
      x: 0,
      rotate: 15
    }} transition={{
      duration: 1,
      delay: 0.4
    }} className="absolute bottom-10 right-10 md:bottom-20 md:right-20 text-palm-500 w-32 h-32 md:w-48 md:h-48 opacity-40" data-id="element-47">
        <PalmLeaf data-id="element-48" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: -50,
      rotate: -90
    }} animate={{
      opacity: 1,
      y: 0,
      rotate: -15
    }} transition={{
      duration: 1,
      delay: 0.6
    }} className="absolute top-1/4 right-10 md:right-1/4 text-coral-500 w-20 h-20 md:w-32 md:h-32 opacity-50" data-id="element-49">
        <CitrusSlice data-id="element-50" />
      </motion.div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-52">
          <span className="inline-block py-1 px-3 rounded-full bg-coral-100 text-coral-900 font-medium text-sm md:text-base mb-6 uppercase tracking-wider" data-id="element-53">
            Premium Domain For Sale
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-display text-5xl md:text-7xl lg:text-8xl text-coral-600 mb-6 leading-tight drop-shadow-sm" data-id="element-54">
          juicyonthebeach<span className="text-citrus-500" data-id="element-55">.com</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-slate-700 mb-8 font-medium" data-id="element-56">
          A premium domain ready for your brand.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-57">
          Owned by José, a professional web developer. Secure this memorable,
          vibrant domain name today and start building your online presence.
        </motion.p>
      </div>
    </section>;
};